// @ts-nocheck
import { createMlbReveal, setupMlbRevealGlobal } from './mlbReveal'

export interface PageScripts { destroy(): void }

/** Vue 3 lifecycle-safe port of DigitalLive's source desktop narrative. */
export function runPageScripts(isMobile: boolean): PageScripts {
  if (typeof window === 'undefined' || typeof document === 'undefined') return { destroy() {} }
  setupMlbRevealGlobal()
  const cleanups: Array<() => void> = []
  const timers: number[] = []
  const rafs: number[] = []
  const reveals: any[] = []
  const later = (fn: () => void, delay: number) => timers.push(window.setTimeout(fn, delay))
  const listen = (target: EventTarget, type: string, fn: EventListener, options?: AddEventListenerOptions) => {
    target.addEventListener(type, fn, options); cleanups.push(() => target.removeEventListener(type, fn, options))
  }
  const frame = (fn: FrameRequestCallback) => rafs.push(window.requestAnimationFrame(fn))
  const reveal = (options: any) => { const item = createMlbReveal(options); reveals.push(item); return item }

  const heroLine1 = document.querySelector('.hero-title-1 .type-text') as HTMLElement
  const heroLine2 = document.querySelector('.hero-title-2 .type-text') as HTMLElement
  const heroCursor1 = document.querySelector('.cursor-blink[data-line="1"]') as HTMLElement
  const heroCursor2 = document.querySelector('.cursor-blink[data-line="2"]') as HTMLElement
  const cta = document.querySelector('.btn-cta') as HTMLElement
  if (heroLine1 && heroLine2 && heroCursor1 && heroCursor2) {
    const hero = reveal({ segments: [{ el: heroLine1, cursor: heroCursor1 }, { el: heroLine2, cursor: heroCursor2 }], onComplete: () => later(() => cta?.classList.remove('btn-cta-hidden'), 120) })
    if (isMobile) { hero.ensureBuilt(); hero.showAllInstant(); cta?.classList.remove('btn-cta-hidden') }
    else {
      // 不等待全部自定义字体（Safari 下方正兰亭黑很大，fonts.ready 会拖很久）
      const startHero = () => later(() => hero.init(), 80)
      if (document.fonts?.ready) {
        Promise.race([
          document.fonts.ready,
          new Promise((resolve) => window.setTimeout(resolve, 500))
        ]).then(startHero)
      } else {
        startHero()
      }
    }
  }

  document.querySelectorAll<HTMLElement>('.cap-section .cap-row').forEach((row) => {
    const title = row.querySelector('.cap-title span[data-text]') as HTMLElement
    const desc = row.querySelector('.cap-desc[data-text]') as HTMLElement
    if (!title || !desc) return
    const titleReveal = reveal({ segments: [{ el: title }] })
    const descReveal = reveal({ segments: [{ el: desc }] })
    // 视频由 CapabilitySection 懒加载并 autoplay；这里只负责文案动效
    if (isMobile) { titleReveal.showAllInstant(); descReveal.showAllInstant(); return }
    let fired = false
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting || fired) return
      fired = true; observer.disconnect()
      titleReveal.playReveal(() => descReveal.playReveal(null, 25), 28)
    }), { threshold: .15 })
    observer.observe(row); cleanups.push(() => observer.disconnect())
  })

  return {
    destroy() {
      cleanups.splice(0).forEach((fn) => fn())
      timers.splice(0).forEach(clearTimeout)
      rafs.splice(0).forEach(cancelAnimationFrame)
      reveals.splice(0).forEach((item) => item.destroy?.())
    }
  }
}
